import React, { createRef, useRef } from 'react';
import * as Styled from './ResultAudioList.styled';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import { resultItem } from '../../../proptypes/Actions';
import TextLabel, { TextLabelTypes } from '../../atoms/TextLabel/TextLabel';
import ResultText from '../../atoms/ResultText/ResultText';

const ResultAudioList = (props) => {
  const audioRefs = React.useMemo(
    () => props.resultItem?.childItems.map(() => React.createRef()) ?? [],
    [props.resultItem.childItems]
  );

  const handlePauseAllExcept = (indexNotToPause) => {
    audioRefs.forEach((audioRef, index) => {
      if (index !== indexNotToPause) {
        audioRef.current.pause();
      }
    });
  };
  return (
    <Styled.Wrapper>
      {props.resultItem.text && (
        <ResultText>{props.resultItem.text}</ResultText>
      )}
      {props.resultItem.childItems.map((child, index) => {
        return (
          <React.Fragment key={child.id}>
            <TextLabel type={TextLabelTypes.GREY_BOLD}>{child.title}</TextLabel>
            <AudioPlayer
              ref={audioRefs[index]}
              onPlay={() => handlePauseAllExcept(index)}
              file={child.audio}
            />
          </React.Fragment>
        );
      })}
    </Styled.Wrapper>
  );
};

ResultAudioList.propTypes = { resultItem: resultItem };

export default ResultAudioList;
